import { useForm } from "antd/lib/form/Form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../shared/types/common";
import { Drawer, Form, Upload, UploadFile } from "antd";
import GenericFormComponent from "../../../shared/components/generic-form/generic-form.component";
import { showNotification } from "../../../shared/utils/utils";
import {
  createProject,
  updateProjectById,
} from "../../../core/store/reducers/project.slice";
import { useEffect, useState } from "react";
import {
  API_GET_ALL_ACCOUNTS_LIST,
  API_GET_ALL_DEPARTMENT_LIST,
  API_GET_ALL_STAFF_LIST,
} from "../../../shared/routes/private.routes";
import { Client } from "../../../core/api-client";
import moment from "moment";
import { read, write } from "fs";
import {
  createAccount,
  updateAccountById,
} from "../../../core/store/reducers/accounts.slice";
import {
  getDocuments,
  getSignedUrl,
} from "../../../core/store/reducers/activity-log.slice";
import { InboxOutlined } from "@ant-design/icons";
import { requestGetByModuleCommon } from "../../../core/store/reducers/master.slice";
interface Props {
  onClose: () => void;
  visible: boolean;
  selectedEntity?: any;
  onSubmit?: () => void;
}

const CreateEditAccountsComponent = ({
  onClose,
  visible,
  selectedEntity = null,
  onSubmit = () => {
    return;
  },
}: Props) => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const { user } = useSelector((state: RootState) => state.auth);
  const { screenType } = useSelector((state: RootState) => state.settings);
  const [selectedStartDate, setSelectedStartDate] = useState<any>(null);
  const [fileList, setFileList] = useState<UploadFile<any>[]>([]);
  const [documents, setDocuments] = useState<any[]>([]);
  const [entityList, setEntityList] = useState<any[]>([]);

  const onFinish = (values: any) => {
    // Split fileList into two groups
    const oldFiles = fileList.filter((file) => !file.originFileObj); // previously uploaded
    const newFiles = fileList.filter((file) => file.originFileObj); // new uploads
    const payload = {
      accountName: values?.accountName,
      accountCode: values?.accountCode,
      clientName: values?.clientName,
      entity: values?.entity,
      status: values?.status,
      ndaSigned: values?.ndaSigned,
      msaStartDate: values?.msaStartDate ? new Date(values?.msaStartDate).toISOString() : null,
      msaEndDate: values?.msaEndDate ? new Date(values?.msaEndDate).toISOString() : null,
      commercial: values?.commercial,
      billing: values?.billing,
    };
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    // Append file (assuming single file upload)
    if (fileList && newFiles.length > 0) {
      newFiles.forEach((fileItem) => {
        const file = fileItem;
        formData.append("files", file.originFileObj as File); // use consistent key name
      });
    }
    const remainingOldFiles = oldFiles.map((file) => ({
      uid: file.uid,
      name: file.name,
      url: file.url,
    }));
    formData.append("oldFiles", JSON.stringify(remainingOldFiles));
    if (selectedEntity) {
      dispatch(
        updateAccountById({ accountId: selectedEntity.accountId, formData })
      ).then((val: any) => {
        if (val?.payload?.data && val?.payload?.data?.statusCode === 200) {
          showNotification("Client Details Updated Successfully", "success");
          onSubmit();
        }
        if (val?.payload?.data && val?.payload?.data?.statusCode === 400) {
          if (val?.payload?.data?.message === "accountAlreadyExistMessage") {
            showNotification("Client Name Already Exist", "warning");
          } else {
            showNotification(val?.payload?.data?.message, "warning");
          }
        }
      });
    } else {
      dispatch(createAccount(formData)).then((val: any) => {
        if (val?.payload?.data && val?.payload?.data?.statusCode === 200) {
          showNotification("New Client Created Successfully", "success");
          onSubmit();
        }
        if (
          val?.payload?.data &&
          val?.payload?.data?.statusCode === 400 &&
          val?.payload?.data?.message === "accountAlreadyExistMessage"
        ) {
          showNotification("Client Name Already Exist", "warning");
        }
      });
    }
  };

  useEffect(() => {
    if (selectedEntity) {
      form.setFieldsValue({
        accountName: selectedEntity?.accountName,
        accountCode: selectedEntity?.accountCode,
        status: selectedEntity.status,
        ndaSigned: selectedEntity?.ndaSigned,
        msaStartDate: selectedEntity?.msaStartDate
          ? moment(selectedEntity?.msaStartDate)
          : null,
        msaEndDate: selectedEntity?.msaEndDate
          ? moment(selectedEntity?.msaEndDate)
          : null,
        commercial: selectedEntity?.commercial,
        billing: selectedEntity?.billing,
        clientName: selectedEntity?.clientName,
        entity: selectedEntity?.entity
      });
    }
  }, [form, selectedEntity]);

  const onFinishFailed = (_errorInfo: any) => {
    return;
  };

  const onValuesChange = (changedValues: any, _allValues: any) => {
    if ("msaStartDate" in changedValues) {
      setSelectedStartDate(_allValues.msaStartDate);
    }
  };

  const disabledDate = (current: moment.Moment | null) => {
    // Disable dates before the start date
    return current && current < moment(selectedStartDate).endOf("day");
  };

  useEffect(() => {
    fetchDocumentList();
    fetchEntityList();
  }, []);

  const fetchEntityList = async () => {
    try {
      const response = await dispatch(
        requestGetByModuleCommon({ module: "master_entity" })
      ).unwrap();
      // console.log(response.data);
      if (response?.success) {
        setEntityList(response?.data.items);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (documents?.length) {
      const converted = documents.map((doc) => ({
        uid: doc.id,
        name: doc.originalFileName,
        status: "done",
        url: doc.bucketPath || "",
      }));

      // Optional: prevent unnecessary state update
      setFileList((prev: any) => {
        const same = JSON.stringify(prev) === JSON.stringify(converted);
        return same ? prev : converted;
      });
    } else {
      setFileList([]); // Clear fileList if documents are empty
    }
  }, [documents]);

  const fetchDocumentList = async () => {
    if (selectedEntity?.accountId) {
      const response = await dispatch(
        getDocuments(selectedEntity?.accountId)
      ).unwrap();
      if (response?.data) {
        setDocuments(response?.data);
        console.log(response?.data, "fetchDocumentList");
      }
    }
  };

  const handleUploadChange = (info: any) => {
    const { file, fileList } = info;

    // Optional: filter duplicates by UID or name
    const uniqueFileList = fileList.filter(
      (file: { uid: any }, index: any, self: any[]) =>
        index === self.findIndex((f) => f.uid === file.uid)
    );
    // .map((file: { originFileObj: any; }) => file.originFileObj);

    setFileList(uniqueFileList);

    if (file.status === "done" || !file.status) {
      showNotification(`${file.name} file uploaded successfully.`, "success");
    } else if (file.status === "error") {
      showNotification(`${file.name} file upload failed.`, "error");
    }
  };

  const handleRemove = (file: any) => {
    // const updatedList = fileList.filter((f) => f.uid !== file.uid);
    // setFileList(updatedList);
  };
  const handleCustomRequest = ({ file, onSuccess }: any) => {
    // Simulate upload success after 0ms
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const beforeUpload = async (file: any) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];
  
    const isValidType = allowedTypes.includes(file.type);
  
    if (!isValidType) {
      showNotification("Only PDF or Word files are allowed", "warning");
      return Upload.LIST_IGNORE;
    }
  
    return false; // Prevent auto upload if you're using customRequest
  };
  var colSpan = screenType.isPortrait ? 24 : 12;

  const formProps = {
    form: form,
    name: "creat-edit-account",
    heading: selectedEntity ? "Edit Client Details" : "Add New Client",
    initialValues: {
      status: "ACTIVE",
    },
    formElements: [
      {
        name: "accountName",
        colSpan: 12,
        label: "Client Name",
        placeholder: "Enter Client Name ",
        type: "Input",
        allowClear: true,
        rules: [{ required: true, message: "Please enter Client Name" }],
      },
      {
        name: "accountCode",
        colSpan: 12,
        label: "Client Type",
        placeholder: "Enter Client Type ",
        type: "Select",
        allowClear: true,
        rules: [{ required: false, message: "Please select Client Type" }],
        options: [
          { value: "Internal", label: "Internal" },
          { value: "External", label: "External" },
        ],
      },
      {
        name: "clientName",
        colSpan: 12,
        label: "Client Legal Entity",
        placeholder: "Enter Client Legal Entity ",
        type: "Input",
        allowClear: true,
        rules: [{ required: true, message: "Please enter Client Legal Entity" }],
      },
      {
        name: "entity",
        colSpan: 12,
        label: "Entity",
        placeholder: "Entity ",
        type: "Select",
        allowClear: true,
        rules: [{ required: true, message: "Please select Entity" }],
        options: entityList?.map((entity) => ({
          value: entity?.id,
          label: entity?.name,
        })),
      },
      // {
      //   name: "billability",
      //   label: "Billability",
      //   placeholder: "Billability",
      //   type: "Select",
      //   rules: [{ required: true, message: "Please enter Billability" }],
      //   colSpan: colSpan,
      //   showSearch: true,
      //   allowClear: true,
      //   options: [
      //     { value: "Billable", label: "Billable" },
      //     { value: "Partially Billable", label: "Partially Billable" },
      //     { value: "Not Billable", label: "Not Billable" },
      //     { value: "NA", label: "NA" }
      //   ],
      // },
      {
        name: "ndaSigned",
        label: "NDA SIGNED",
        placeholder: "NDA SIGNED",
        type: "Select",
        rules: [{ required: true, message: "Please select NDA SIGNED" }],
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: [
          { value: "YES", label: "YES" },
          { value: "NO", label: "NO" }
        ],
      },
      {
        name: "status",
        label: "status",
        placeholder: "status",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: [
          { value: "ACTIVE", label: "ACTIVE" },
          { value: "INACTIVE", label: "INACTIVE" },
          // { value: "RAISED", label: "RAISED" }
        ],
        rules: [{ required: true, message: "Please enter Status" }],
      },
      {
        name: "msaStartDate",
        label: "MSA Start Date",
        placeholder: "MSA Start Date",
        type: "DatePicker",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        rules: [{ required: false, message: "Please enter MSA Start Date" }],
      },
      {
        name: "msaEndDate",
        label: "MSA End Date",
        placeholder: "MSA End Date",
        type: "DatePicker",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        rules: [{ required: false, message: "Please enter MSA End Date" }],
        disabledDate: disabledDate,
      },
      // {
      //   name: "commercial",
      //   colSpan: 12,
      //   label: "Commercial",
      //   placeholder: "Enter Commercial",
      //   type: "Input",
      //   allowClear: true,
      //   rules: [{ required: false, message: "Please enter Commercial" }],
      //   fieldProps: {
      //     inputMode: "numeric", // mobile-friendly numeric keypad
      //     onKeyDown: (e: any) => {
      //       // Prevent typing non-numeric characters
      //       if (
      //         !/[0-9]/.test(e.key) &&
      //         e.key !== "Backspace" &&
      //         e.key !== "Delete" &&
      //         e.key !== "ArrowLeft" &&
      //         e.key !== "ArrowRight"
      //       ) {
      //         e.preventDefault();
      //       }
      //     },
      //   },
      // },
      // {
      //   name: "billing",
      //   colSpan: 12,
      //   label: "Billing",
      //   placeholder: "Enter Billing",
      //   type: "Input",
      //   allowClear: true,
      //   rules: [{ required: false, message: "Please enter Billing" }],
      //   fieldProps: {
      //     inputMode: "numeric", // mobile-friendly numeric keypad
      //     onKeyDown: (e: any) => {
      //       // Prevent typing non-numeric characters
      //       if (
      //         !/[0-9]/.test(e.key) &&
      //         e.key !== "Backspace" &&
      //         e.key !== "Delete" &&
      //         e.key !== "ArrowLeft" &&
      //         e.key !== "ArrowRight"
      //       ) {
      //         e.preventDefault();
      //       }
      //     },
      //   },
      // },
      {
        name: "files", // or any identifier
        label: "Upload File",
        type: "Custom",
        colSpan: 16,
        render: ({} = {}) => (
          <Form.Item
            name="file"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
            rules={[{ required: false }]}
          >
            <div style={{ maxHeight: 400 }}>
              <Upload.Dragger
                name="file"
                multiple={true}
                listType="text"
                showUploadList={{ showRemoveIcon: true }}
                fileList={fileList}
                onChange={handleUploadChange}
                onRemove={handleRemove}
                customRequest={handleCustomRequest}
                beforeUpload={beforeUpload}
                accept=".pdf,.doc,.docx"
                style={{ padding: "16px 0", backgroundColor: "#dcdcdc" }}
                onPreview={async (file) => {
                  try {
                    console.log(file);
                    if (file.url) {
                      const res = await dispatch(
                        getSignedUrl({
                          module: "account",
                          params: { url: file.url },
                        })
                      ).unwrap();

                      console.log(res, getSignedUrl);
                      if (res?.data?.url) {
                        window.open(res.data.url, "_blank");
                      }
                    }
                  } catch (e) {
                    console.log("Could not open file");
                  }
                }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Upload.Dragger>
            </div>
          </Form.Item>
        ),
      },
    ],
    extraButtons: [
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Cancel",
        onClick: onClose,
      },
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Clear",
        type: "clearForm",
      },
      {
        htmlType: "submit",
        colSpan: 5,
        loading: false,
        submitButtonText: "Save",
        submitButtonType: "primary",
      },
    ],
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: onValuesChange,
  };

  return (
    <>
      <Drawer
        maskClosable={false}
        title={<strong>{formProps.heading}</strong>}
        className="form-drawer"
        width={
          screenType.isPortrait
            ? "90%"
            : screenType.isLg || screenType.isXl
            ? 720
            : 500
        }
        onClose={onClose}
        open={visible}
      >
        <GenericFormComponent {...formProps} />
      </Drawer>
    </>
  );
};
export default CreateEditAccountsComponent;
